import Card from "antd/es/card/Card";
import Brands from "entities/Brand";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdOutlineUploadFile } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";
import ImportModal from "./ImportModal";
import View from "./View";

const List = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.BRAND);
  const LIST = t("LIST", { returnObjects: true });
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState("");
  const [importModalOpen, setImportModalOpen] = useState(false);
  const filter = {
    like: isEmpty(search)
      ? undefined
      : {
          OR: [{ name: `%${search}%` }, { models: { name: `%${search}%` } }],
        },
  };
  const navigate = useNavigate();

  const buttons = [
    {
      icon: <MdOutlineUploadFile size={24} />,
      text: LIST.HEADER.IMPORT,
      onClick: () => setImportModalOpen(true),
      type: "primary--outlined",
    },
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () =>
        navigate(SCREENS.PRIVATE.ADMIN.BRANDS.CREATE.path, {
          state: { ...filter, ...pagination },
        }),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <Brands
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
        />
      </Card>
      <ImportModal
        isOpen={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={() => setPagination((prev) => ({ ...prev }))}
      />
    </>
  );
};

export default List;
